import React from 'react'
import PropTypes from 'prop-types'
import Grid from '@material-ui/core/Grid'

const OtherStories = ({
  className,
  header,
  inspirationalQuote,
  render,
  ...props
}) => (
  <Grid
    spacing={40}
    classes={{ container: className }}
    justify="center"
    alignItems="center"
    {...props}
    container
  >
    <Grid xs={12} item>
      {header}
    </Grid>
    <Grid xs={12} item>
      {inspirationalQuote}
    </Grid>
    {render(Story)}
  </Grid>
)

OtherStories.propTypes = {
  className: PropTypes.string.isRequired,
  header: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  inspirationalQuote: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
    .isRequired,
  render: PropTypes.func.isRequired,
}

function Story({ top, bottom, ...otherProps }) {
  return (
    <Grid xs={12} sm={12} md={4} xl={3} {...otherProps} item>
      {top}
      {bottom}
    </Grid>
  )
}

Story.propTypes = {
  top: PropTypes.node.isRequired,
  bottom: PropTypes.node.isRequired,
}

export default OtherStories



// WEBPACK FOOTER //
// ./src/components/Storiespage/OtherStories.js